// @flow

import middleware from "./middleware"

export default middleware;



// WEBPACK FOOTER //
// ./src/Store/Middleware/CrashReporter/index.js